module.exports = __webpack_public_path__ + "img/Ba_bg.7334e54f.png";